import { Link } from 'react-router-dom';
import IconProcessed from '../../../images/processed.svg';
import './processed.scss';

const Processed = () => {
    const handleBackLanding = () => {
        window.open('https://rpp.pe/empresasquetransforman', '_self');
    };

    return (
        <div className="ProcessedWrapFull">
            <div className="ProcessedLogo">
                <img
                    alt="Empresas que transforman el Perú"
                    src="/images/logo.png"
                    onClick={handleBackLanding}
                />
            </div>
            <div className="ProcessedWrap">
                <div className="ProcessedWrapInner">
                    <img src={IconProcessed} alt="" />
                    <h4 className="ProcessedTitle">
                        ¡Tu registro está siendo procesado!
                    </h4>
                    <p className="mb2">
                        Revisa tu correo electrónico para poder<br></br>
                        habilitar tu cuenta
                    </p>
                    <Link className="button buttonAuto" to="/signin">
                        Aceptar
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default Processed;
